import { apiClient } from './api-client';

export interface Role {
  id: string;
  tenantId: string;
  name: string;
  slug: string;
  description: string | null;
  isSystem: boolean;
  isDefault: boolean;
  permissions: string[];
  createdAt: string;
  updatedAt: string;
}

export const rolesService = {
  listAll: (): Promise<Role[]> => apiClient.get<Role[]>('/roles').then((r) => r.data),

  get: (id: string): Promise<Role> => apiClient.get<Role>(`/roles/${id}`).then((r) => r.data),
};
